import snowplow from 'snowplow-tracker'
import store from '@/store'

const COLLECTOR_ENDPOINT_DEV = 'com-camparound.mini.snplow.net'
const COLLECTOR_ENDPOINT_PROD = 'com-camparound-main.collector.snplow.net'
const COLLECTOR_PROTOCOL = 'https'
const COLLECTOR_METHOD = 'GET'

const TRACKER_APP_ID = 'com.camparound'
const TRACKER_NAMESPACE = 'booking-engine'

const IS_BVCD =
  process.env.VUE_APP_BVCD !== '' &&
  process.env.VUE_APP_BVCD !== null &&
  process.env.VUE_APP_BVCD !== undefined

const JOB_ID = Number(process.env.build.JOB_ID || 1)

const collectorEndpoint = () => {
  if (store.getters['application/testmode'] === null) {
    return null
  }
  if (store.getters['application/testmode']) {
    return COLLECTOR_ENDPOINT_DEV
  }
  return !(
    !process.env.VUE_APP_SNOWPLOW_IS_LIVE || process.env.VUE_APP_SNOWPLOW_IS_LIVE === 'false'
  )
    ? COLLECTOR_ENDPOINT_PROD
    : COLLECTOR_ENDPOINT_DEV
}

const schemaGenerator = (eventName, eventVersion) =>
  `iglu:${TRACKER_APP_ID}/${eventName}/jsonschema/${eventVersion}`

const productInformation = () => ({
  schema: schemaGenerator('product_information', '1-0-0'),
  data: {
    product_platform: 'Web',
    product_vendor: IS_BVCD ? 'BVCD-Booking Engine' : 'CI-Booking Engine',
    product_type: 'Booking Engine Frontend',
    product_version: '2.1.3',
    product_build: JOB_ID,
  },
})

const Snowplow = {
  buffer: [],
  readyCheckInterval: null,
  install(Vue) {
    const plower = {
      trackUnstructEvent: payloads => {
        Snowplow.buffer.push(payloads)
      },
      trackStep: stage => {
        plower.trackUnstructEvent([
          {
            evtVer: '1-0-1',
            evtName: 'booking_fe_steps',
            data: {
              fe_session_id: store.getters['application/frontendSessionId'],
              stage: stage,
            },
          },
        ])
      },

      trackErrors: errors => {
        plower.trackUnstructEvent([
          {
            evtVer: '1-0-1',
            evtName: 'booking_fe_errors',
            data: {
              fe_session_id: store.getters['application/frontendSessionId'],
              errors: errors.join(','),
            },
          },
        ])
      },
    }
    Object.defineProperty(Vue.prototype, '$snowplow', {
      get: () => plower,
    })
    if (store.getters['application/testmode'] === null) {
      Snowplow.readyCheckInterval = setInterval(() => {
        if (store.getters['application/testmode'] !== null) {
          clearInterval(Snowplow.readyCheckInterval)
          this._install(Vue)
        }
      }, 10)
    } else {
      this._install(Vue)
    }
  },
  _install(Vue) {
    const emitter = snowplow.emitter(
      collectorEndpoint(),
      COLLECTOR_PROTOCOL,
      null,
      COLLECTOR_METHOD,
      1,
      () => {},
      { maxSockets: 100 }
    )

    this.tracker = snowplow.tracker(emitter, TRACKER_NAMESPACE, TRACKER_APP_ID, false)

    Vue.prototype.$snowplow.trackUnstructEvent = payloads => {
      const events = []
      payloads.forEach(payload => {
        events.push({
          schema: schemaGenerator(payload.evtName, payload.evtVer),
          data: payload.data,
        })
      })
      this.tracker.trackUnstructEvent(productInformation(), events)
    }

    while (Snowplow.buffer.length) {
      Vue.prototype.$snowplow.trackUnstructEvent(Snowplow.buffer.shift())
    }
  },
}

export default Snowplow
